import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectValuationHostComponent } from './project-valuation-host/project-valuation-host.component';
import { RouterModule } from '@angular/router';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TranslateModule } from '@ngx-translate/core';
import { UploadsModule } from "@progress/kendo-angular-upload";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { AppCommonModule } from '../../components/common/app-common.module';
import { ImportWizardComponent } from './import/import-wizard/import-wizard.component';
import { ParticipantsAssignmentComponent } from '../raci/components/participants-assignment/participants-assignment.component';
import { PropertiesComparablesSidebarComponent } from '../../navigation/project-valuation/properties-navigation/properties-comparables-sidebar/properties-comparables-sidebar.component';
import { ValuationEventPropertiesComponent } from './components/valuation-event-properties/valuation-event-properties.component';
import { ValuationEventCurrenciesComponent } from './components/valuation-event-currencies/valuation-event-currencies.component';
import { ExportWizardComponent } from './export/export-wizard/export-wizard.component';
import { ValuationEventParticipantsComponent } from './components/valuation-event-participants/valuation-event-participants.component';
import { ExternalRatesDialogComponent } from './components/valuation-event-currencies/dialog/external-rates-dialog.component';
import { ProjectsGridExportPaneComponent } from './components/projects-grid-export-pane/projects-grid-export-pane.component';
import { ProjectsSearchFormComponent } from './components/searchForms/projects-search-form/projects-search-form.component';
import { ProjectsGridComponent } from './components/grids/projects-grid/projects-grid.component';
import { ProjectsWorkspaceComponent } from './components/workspaces/projects-workspace/projects-workspace.component';
import { PropertyInfobarPicturesComponent } from './components/infobar/property-infobar-pictures/property-infobar-pictures.component';
import { ProjectsFormComponent } from './components/forms/projects-form/projects-form.component';
import { PropertiesComparablesDeleteSidebarComponent } from '../../navigation/project-valuation/properties-navigation/properties-comparables-delete-sidebar/properties-comparables-delete-sidebar.component';
import { ReportsSearchFormComponent } from './components/searchForms/reports-search-form/reports-search-form.component';
import { FileAttachmentListComponent } from './components/infobar/file-attachment-list/file-attachment-list.component';
import { PortfoliosSearchFormComponent } from './components/searchForms/portfolios-search-form/portfolios-search-form.component';
import { ValuationsGridComponent } from './components/grids/valuations-grid/valuations-grid.component';
import { ReportsGridComponent } from './components/grids/reports-grid/reports-grid.component';
import { ValuationsWorkspaceComponent } from './components/workspaces/valuations-workspace/valuations-workspace.component';
import { TenantsWorkspaceComponent } from './components/workspaces/tenants-workspace/tenants-workspace.component';
import { TenantsGridComponent } from './components/grids/tenants-grid/tenants-grid.component';
import { TenantsFormComponent } from './components/forms/tenants-form/tenants-form.component';
import { ValuationEventsFormComponent } from './components/forms/valuation-events-form/valuation-events-form.component';
import { ValuationEventsGridComponent } from './components/grids/valuation-events-grid/valuation-events-grid.component';
import { ValuationEventsWorkspaceComponent } from './components/workspaces/valuation-events-workspace/valuation-events-workspace.component';
import { PropertiesWorkspaceComponent } from './components/workspaces/properties-workspace/properties-workspace.component';
import { PropertiesGridComponent } from './components/grids/properties-grid/properties-grid.component';
import { CalculationModelAssignComponent } from '../app-settings/components/calculation-model/calculation-model-assign/calculation-model-assign.component';
import { ReportsFormComponent } from './components/forms/reports-form/reports-form.component';
import { ReportsWorkspaceComponent } from './components/workspaces/reports-workspace/reports-workspace.component';
import { ProjectValuationWorkplaceComponent } from './components/workplace/project-valuation-workplace/project-valuation-workplace.component';
import { NavigationModule } from '../../navigation/navigation.module';
import { ProjectValuationInfobarComponent } from './components/infobar/project-valuation-infobar/project-valuation-infobar.component';
import { ProjectInfobarPictures } from './components/infobar/project-infobar-pictures/project-infobar-pictures.component';
import { AppPublishValidationDialogComponent } from './components/app-publish-validation-dialog/app-publish-validation-dialog.component';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog'; // Import KendoWindowModule
import { ProjectValuationRoutingModule } from './project-valuation.routing.module';
import { CopyValuationEventFormComponent } from './components/forms/copy-valuation-event-form/copy-valuation-event-form.component';
import { CopyValuationPortfolioDialogComponent } from './components/dialog/copy-valuation-portfolio-dialog/copy-valuation-portfolio-dialog.component';
import { AppPublishDialogComponent } from './components/dialog/app-publish-dialog/app-publish-dialog.component';
import { RaciModule } from '../raci/raci.module';

/**
 * Project valuation module
 */
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: ProjectValuationHostComponent
      }
    ]),
    ProjectValuationRoutingModule,
    GridModule,
    ExcelModule,
    DropDownsModule,
    ReactiveFormsModule,
    ButtonsModule,
    TranslateModule,
    UploadsModule,
    FormsModule,
    LayoutModule,
    InputsModule,
    AppCommonModule,
    DateInputsModule,
    NavigationModule,
    DialogModule,
    RaciModule,
    WindowModule
  ],
  declarations: [
    AppPublishValidationDialogComponent,
    ProjectValuationHostComponent,
    ProjectValuationInfobarComponent,
    ImportWizardComponent,
    ExportWizardComponent,
    ParticipantsAssignmentComponent,
    PropertiesComparablesSidebarComponent,
    PropertiesComparablesDeleteSidebarComponent,
    ValuationEventPropertiesComponent,
    ValuationEventParticipantsComponent,
    ValuationEventCurrenciesComponent,
    ExternalRatesDialogComponent,
    ProjectsGridExportPaneComponent,
    ProjectsSearchFormComponent,
    ProjectsGridComponent,
    ProjectsWorkspaceComponent,
    PropertyInfobarPicturesComponent,
    ProjectsFormComponent,
    PropertyInfobarPicturesComponent,
    ReportsSearchFormComponent,
    ProjectsFormComponent,
    FileAttachmentListComponent,
    PortfoliosSearchFormComponent,
    ValuationsGridComponent,
    ReportsGridComponent,
    ValuationsWorkspaceComponent,
    TenantsGridComponent,
    TenantsWorkspaceComponent,
    TenantsFormComponent,
    PropertiesWorkspaceComponent,
    PropertiesGridComponent,
    ValuationEventsFormComponent,
    ValuationEventsGridComponent,
    ValuationEventsWorkspaceComponent,
    CalculationModelAssignComponent,
    ReportsFormComponent,
    ReportsGridComponent,
    ReportsWorkspaceComponent,
    ProjectValuationWorkplaceComponent,
    ProjectValuationInfobarComponent,
    ProjectInfobarPictures,
    CopyValuationPortfolioDialogComponent,
    CopyValuationEventFormComponent,
    AppPublishDialogComponent
  ]
})
export class ProjectValuationModule { }
